import { type AppModus, useCanvasStore } from "../../../hooks/useCanvasStore";
import { useNavigation } from "../../../hooks/useNavigation";
import FloatingButton from "../../FloatingButton";

interface FloatingMenuButtonProps {
	step: string;
	label: string;
	mode: AppModus;
}

export default function FloatingMenuButton(props: FloatingMenuButtonProps) {
	const { step, label, mode } = props;
	const { appMode } = useCanvasStore();
	const { navigate } = useNavigation();

	const active = mode === appMode;

	return (
		<FloatingButton
			onClick={() => navigate(mode)}
			active={active}
			step={step}
			label={label}
			side="right"
		/>
	);
}
